import EndUrls from "../endUrls";   
import { patchService } from "../services";

export const changeStatus = async ({ id, status }) => {
   try {
      const data = {
         driver_master_id: id, // lane master id lane_masters table
         is_active: status,
         model_id: 4,
         action_id: 2,
      };

      /************  Pending for api endpoint****************/
      const { data: res } = await patchService(EndUrls.changeLaneStatus, data, true);

      if (res.statusCode === 200) {
         return res;
      } else {
         throw new Error(res.message);
      }
   } catch (error) {
      throw error;
   }
};
